function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.assign.js";
import React from 'react';
import { withTheme } from 'styled-components';
import { Datalayer } from '@finect/front-gtm';
import { LayerLink } from '@finect/front-core/Links';
import { Inner, Content, Disclaimer } from './partials';
import { DATA_BY_SPONSOR } from './data';
var DEFAULT_CTA = 'Me interesa';
var DEFAULT_COLOR = 'primary';
var DEFAULT_COLOR_CTA = 'primary';
var SponsoredContent = function SponsoredContent(props) {
  var data = DATA_BY_SPONSOR[props.id] || DATA_BY_SPONSOR.default;
  var linkProps = {
    as: LayerLink,
    href: props.link
  };
  var linkLayer = {
    id: 'FiEvent',
    type: 'fiEvent',
    params: {
      category: 'AdNativeClick',
      action: props.link,
      label: "ad-native-".concat(props.id)
    }
  };
  return React.createElement(Inner, null, React.createElement(Datalayer, {
    id: "FiEvent",
    type: "fiEvent",
    params: {
      category: 'AdNativeImpression',
      action: "".concat(props.id, " AdNative Embedded"),
      label: "ad-native-".concat(props.id)
    }
  }), React.createElement(Content, _extends({
    color: props.color || data.color || DEFAULT_COLOR,
    colorCTA: props.colorCTA || DEFAULT_COLOR_CTA,
    font: data.font || '-2',
    fontPhone: data.fontPhone || '-3',
    layer: linkLayer,
    rel: data.rel,
    target: "_blank"
  }, linkProps), React.createElement("div", {
    className: "image-container"
  }, React.createElement("img", {
    src: props.logo || data.logo,
    alt: "logo ".concat(data.id)
  }), React.createElement("button", {
    className: "mobile"
  }, props.cta || data.cta || DEFAULT_CTA)), React.createElement("div", {
    className: "content"
  }, props.text ? React.createElement("p", null, props.text) : data.content.map(function (content, index) {
    return React.createElement("p", {
      key: index
    }, content);
  })), React.createElement("button", {
    className: "desktop"
  }, props.cta || data.cta || DEFAULT_CTA)), data.disclaimer && React.createElement(Disclaimer, null, data.disclaimer));
};
export default withTheme(SponsoredContent);